import useBranding from "hooks/useBranding";
import { useEffect, useRef, useState } from "react";
import './Pod.scss';

const Pod = ({ children, title = "title", mobileOrder, sticky = false }) => {
	const { whitelabelled, gradient, watermark } = useBranding();
	const mobileWidth = 1024;
	const [isMobile, setIsMobile] = useState(window.innerWidth < mobileWidth);
	const defaultOffset = 30;
	const [topOffset, setTopOffset] = useState(defaultOffset);
	const [lastScrollY, setLastScrollY] = useState(0);
	const podRef = useRef(null);

	useEffect(() => {
		const handleResize = () => {
			const width = window.innerWidth;
			setIsMobile(width < mobileWidth);
		};

		handleResize(); 
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	useEffect(() => {
		if (!sticky || isMobile) {
			return;
		}

		const handleScroll = () => {
			if (!podRef.current) {
				return;
			}

			const scrollY = window.scrollY;
			const windowHeight = window.innerHeight;
			const podHeight = podRef.current.offsetHeight;

			let newTopOffset = topOffset;

			if (podHeight > windowHeight) {
				if (scrollY > lastScrollY) {
					newTopOffset = Math.min(windowHeight - podHeight, newTopOffset + (scrollY - lastScrollY));
				}
				else {
					newTopOffset = Math.max(defaultOffset, newTopOffset - (lastScrollY - scrollY));
				}

				setTopOffset(newTopOffset);
				setLastScrollY(scrollY);
			}
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, [sticky, isMobile, topOffset, lastScrollY]);

	const mobileOrderStyle = isMobile && mobileOrder ? { gridRow: mobileOrder } : {};

	return (
		<div
			ref={podRef}
			className={`pod ${sticky && !isMobile ? "sticky" : ""}`} // Remove sticky class if mobile
			style={{
				...mobileOrderStyle,
				...(sticky && !isMobile ? { position: "sticky", top: `${topOffset}px` } : {}), // Apply sticky only if not mobile
			}}
		>
			<div className="podHeader">
				<h1>{title}</h1>
				{watermark && <img alt="Pod Background Detail" className={`podHeader-image${whitelabelled ? "" : " default"}`} src={watermark} />}
				{gradient && <span className="podHeader-grad"></span>}
			</div>
			<div className="podBody">{children}</div>
		</div>
	);
};

export default Pod;
